export default Object.freeze({
  Pending: 1,
  Executing: 2,
  Success: 3,
  Error: 4,
  Failed: 5,
});
